import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isHome && !scrolled
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-open-line text-lg text-white"></i>
            </div>
            <span className={`font-heading text-xl font-bold ${isHome && !scrolled ? 'text-white' : 'text-foreground-950'}`}>
              韩漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                location.pathname === '/'
                  ? isHome && !scrolled ? 'text-white border-b-2 border-white' : 'text-primary-500 border-b-2 border-primary-500'
                  : isHome && !scrolled ? 'text-white/80 hover:text-white' : 'text-foreground-700 hover:text-foreground-950'
              } pb-1`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                location.pathname.startsWith('/category')
                  ? isHome && !scrolled ? 'text-white border-b-2 border-white' : 'text-primary-500 border-b-2 border-primary-500'
                  : isHome && !scrolled ? 'text-white/80 hover:text-white' : 'text-foreground-700 hover:text-foreground-950'
              } pb-1`}
            >
              分类
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors ${
                location.pathname === '/about'
                  ? isHome && !scrolled ? 'text-white border-b-2 border-white' : 'text-primary-500 border-b-2 border-primary-500'
                  : isHome && !scrolled ? 'text-white/80 hover:text-white' : 'text-foreground-700 hover:text-foreground-950'
              } pb-1`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索韩漫..."
                className="w-48 px-4 py-2 pr-10 text-sm bg-background-100 border border-background-200/70 rounded-full focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-all text-foreground-800 placeholder-foreground-400"
              />
              <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${isHome && !scrolled ? 'text-white' : 'text-foreground-950'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 shadow-lg">
            <div className="flex flex-col px-4 py-3 gap-2">
              <Link to="/" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap">首页</Link>
              <Link to="/category/all" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap">分类</Link>
              <Link to="/about" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap">关于我们</Link>
              <div className="pt-2">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="搜索韩漫..."
                    className="w-full px-4 py-2 pr-10 text-sm bg-background-100 border border-background-200/70 rounded-full focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-all text-foreground-800 placeholder-foreground-400"
                  />
                  <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
                </div>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}